import { Controller, useFormContext, useFormState, useWatch } from 'react-hook-form';

import { Select as AntdSelect, Checkbox } from 'antd';

import { ErrorMessage } from './ErrorMessage';
import { InputLabel } from '../ui/InputLabel';

interface IProps {
  id: string;
  placeholder?: string;
  values: { label: string; value: string }[];
  modalTitle?: string;
  name: string;
  label?: string;
  multiple?: boolean;
  maxItems?: number;
  disabled?: boolean;
  onFocus?: React.FocusEventHandler<HTMLElement>;
}

export const Select = ({
  id,
  placeholder,
  values,
  name,
  multiple = false,
  disabled,
  maxItems = 10000,
  label,
  onFocus
}: IProps) => {
  const { control } = useFormContext();
  const { errors } = useFormState({ control });

  const currentItems = useWatch({ control, name });
  const message = errors[name]?.message as string | undefined;

  return (
    <div>
      <InputLabel>{label}</InputLabel>
      <Controller
        control={control}
        name={name}
        rules={{ required: true }}
        render={({ field }) => {
          const { onChange, ...restField } = field;

          return (
            <AntdSelect
              className='w-full'
              status={message ? 'error' : ''}
              id={id}
              placeholder={placeholder}
              mode={multiple ? 'multiple' : undefined}
              optionFilterProp='label'
              disabled={disabled}
              menuItemSelectedIcon={null}
              options={values}
              onFocus={onFocus}
              onChange={val => {
                if (val.length <= maxItems) {
                  onChange(val);
                }
              }}
              popupRender={menu => (
                <div>
                  {multiple && (
                    <div className='border-b border-gray-200 px-3 py-2 text-gray-500'>Máximo de {maxItems} itens</div>
                  )}
                  {menu}
                </div>
              )}
              optionRender={opt => {
                return (
                  <div className='flex items-center gap-2'>
                    {multiple && (
                      <Checkbox
                        id={`item-${opt.value}`}
                        checked={currentItems.includes(opt.value)}
                        disabled={!currentItems.includes(opt.value) && currentItems.length >= maxItems}
                      />
                    )}
                    {opt.label}
                  </div>
                );
              }}
              {...restField}
            />
          );
        }}
      />
      <ErrorMessage fieldName={name} />
    </div>
  );
};
